/* eslint-disable no-undef */
import sma from "@/utils/sma";
import ajax from "@/utils/ajax";
import router from "@/router/index";

const TYPE = {
  wechatMessage: 1,
  wechatTimeline: 2,
  app: 3,
  dingDing: 4,
};
// 微信配置是否好了
let wxIsReady = false;

// 分享配置
const share = {
  link: window.location.href,
  title: "",
  desc: "",
  img: "",
  isShareImage: 0,
  successCallback: null,
};

// 设置分享配置
export function setShareConfig(config) {
  share.link = config?.link ?? window.location.href;
  share.title = config?.title ?? "";
  share.desc = config?.desc ?? "";
  share.img = config?.img ?? "";
  share.isShareImage = config?.isShareImage ?? 0;
  share.successCallback = config?.successCallback ?? null;
  setAppShareConfig();
  if (wxIsReady && router.mode === "hash") {
    setWXShareConfig();
  } else {
    initWXConfig();
  }
  setDingDingShareConfig();
}
// 获取位置信息
export function getLocation(callback) {
  if (!wxIsReady) {
    initWXConfig();
  }
  wx.getLocation({
    type: "wgs84",
    success: function (res) {
      callback(res.longitude, res.latitude);
      // location.latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
      // location.longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
    },
    fail: function (res) {
      callback("", "", res.errMsg);
    },
  });
}

/**
 * 调起APP的分享
 * @param {*} config 分享配置
 */
export function launchAppShare() {
  if (sma?.isApp?.scienceChina ?? false) {
    window.appShareCallbackFunction = () => {
      share.successCallback && share.successCallback(TYPE.app);
    };
    sma.share({
      link: share.link,
      title: share.title,
      desc: share.desc,
      imgUrl: share.img,
      isShareImage: share.isShareImage.toString(),
      async: false,
      callbackId: "appShare",
      callbackFunction: "window.appShareCallbackFunction",
    });
  }
}

/**
 * 设置App分享
 */
function setAppShareConfig() {
  if (sma?.isApp?.scienceChina ?? false) {
    window.appShareCallbackFunction = () => {
      share.successCallback && share.successCallback(TYPE.app);
    };
    sma.setShareInfo({
      link: share.link,
      title: share.title,
      desc: share.desc,
      imgUrl: share.img,
      isShareImage: share.isShareImage.toString(),
      async: false,
      callbackId: "appShare",
      callbackFunction: "window.appShareCallbackFunction",
    });
  }
}

/**
 * 初始化微信配置
 * @returns
 */
async function initWXConfig() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) != "micromessenger") {
    return;
  }
  try {
    const res = await ajax.get("/wx/getWxToken", {
      baseURL: process.env.VUE_APP_H5_API,
      addSignature: false,
      addToken: false,
      withCredentials: false,
      params: {
        url: encodeURI(location.href.split("#")[0]),
        wxNum: 7,
      },
    });
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: res.data.appId, // 必填，公众号的唯一标识
      timestamp: res.data.timestamp, // 必填，生成签名的时间戳
      nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
      signature: res.data.signature, // 必填，签名
      jsApiList: [
        "updateAppMessageShareData",
        "updateTimelineShareData",
        "getLocation",
      ], // 必填，需要使用的JS接口列表
    });
    wx.ready(() => {
      wxIsReady = true;
      setWXShareConfig();
    });
  } catch (error) {
    console.error("获取微信分享配置失败");
  }
}

/**
 * 设置微信分享
 */
function setWXShareConfig() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) != "micromessenger") {
    return;
  }
  if (!wxIsReady) {
    console.log("微信未初始化");
    return;
  }
  // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
  wx.updateAppMessageShareData({
    title: share.title, // 分享标题
    desc: share.desc, // 分享描述
    link: share.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: share.img, // 分享图标
    success: function () {
      // 分享成功
      share.successCallback && share.successCallback(TYPE.wechatMessage);
    },
  });
  // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
  wx.updateTimelineShareData({
    title: share.title, // 分享标题
    link: share.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: share.img, // 分享图标
    success: function () {
      // 分享成功
      share.successCallback && share.successCallback(TYPE.wechatTimeline);
    },
  });
}

/**
 * 设置钉钉分享
 */
function setDingDingShareConfig() {
  // 钉钉分享
  if (!window.dd || !dd.version) {
    return;
  }
  dd.ready(function () {
    dd.biz.navigation.setRight({
      show: true,
      control: true,
      showIcon: true,
      onSuccess: function () {
        dd.biz.util.share({
          type: 0, //分享类型，0:全部组件 默认；1:只能分享到钉钉；2:不能分享，只有刷新按钮
          url: share.link,
          title: share.title,
          content: share.desc,
          image: share.img,
          onSuccess: function () {
            share.successCallback && share.successCallback(TYPE.dingDing);
          },
          onFail: function () {},
        });
      },
    });
  });
}
